import { inject, observer } from 'mobx-react';
import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import Hubspot from 'app/main/common/Hubspot';
import HubspotButton from 'app/main/common/HubspotButton';
import Utils from 'utils/Utils';

const useStyles = makeStyles()({
    root: {
        padding: 100,
        position: 'relative',
        overflow: 'hidden',
        '@media (max-width: 1140px)': {
            padding: 'initial',
            paddingBottom: 100
        }
    },
    slide: {
        maxWidth: 1180,
        margin: '50px auto 100px',
        position: 'relative',
        padding: '100px 80px',
        background: '#f6f7fa',
        borderRadius: 28,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexWrap: 'wrap-reverse',
        '@media (max-width: 1140px)': {
            flexDirection: 'column-reverse',
            margin: '20px auto 0',
            alignContent: 'center',
            padding: '20px 0 0',
            '&:nth-child(2)': {
                flexDirection: 'column'
            }
        }
    },
    box: {
        maxWidth: 480,
        '@media (max-width: 1140px)': {
            padding: 20
        }
    },
    title: {
        fontSize: 36
    },
    description: {
        fontSize: 18,
        paddingTop: 24,
        paddingBottom: 48
    },
    button: {
        fontSize: 16,
        padding: '16px 40px',
        borderRadius: 100
    },
    img: {
        maxWidth: 460,
        '@media (max-width: 1140px)': {
            marginBottom: 40
        },
        '@media (max-width: 720px)': {
            maxWidth: '100%',
            marginBottom: 10
        }
    }
});

const SDK = () => {
    const { classes } = useStyles();
    const history = useHistory();

    const handleClick = (e) => {
        e.preventDefault();
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
        history.push('/sdk');
    };

    return (
        <Box className={classes.root} id="sdk">
            <Box className={classes.slide}>
                <Box display="flex" flexDirection="column" alignItems="flex-start" className={classes.box}>
                    <Typography className={classes.title} variant="h2">
                        Develop your own
                        <br />
                        security product
                    </Typography>
                    <Typography className={classes.description} variant="body2">
                        Integrate vulnerability detection into your product or create your own vulnerability management
                        product fully customized to your tasks using our ready-to-use API wrapper and Python SDK
                    </Typography>
                    <HubspotButton
                        hubspot={Hubspot.LANDING_MAIN_SDK_LEARN_MORE}
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        href="/sdk"
                        onClick={handleClick}
                    >
                        Learn More
                    </HubspotButton>
                </Box>
                <img src={Utils.getImage('landing/v2/benefit/sdk')} alt="Vulners Python SDK" className={classes.img} />
            </Box>
        </Box>
    );
};

export default inject('statsStore')(observer(SDK));
